import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';
import { inject } from 'vue';
import { beforeEachHandler } from './before-each-handler.js';


/**
 * These are the core, built-in routes.
 */
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../core-components/login/login.vue'),
      meta: { layout: 'fullBleed', noAuth: true },
    },
    {
      path: '/notauthorized',
      name: 'notAuthorized',
      component: () => import('../core-components/notauthorized.vue'),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('../core-components/dashboard.vue'),
    },
    // {
    //   path: '/temphome',
    //   name: 'tempHome',
    //   component: () => import('./temp-home-2.vue'),
    // },
    // {
    //   path: '/uiplayground',
    //   name: 'uiPlayground',
    //   component: () => import('../core-components/ui-playground/ui-playground.vue'),
    // },
    // {
    //   path: '/uiplayground2',
    //   name: 'uiPlayground2',
    //   component: () => import('../core-components/ui-playground/ui-playground-2.vue'),
    // },
  ]
});

export default router;


/**
 *  Before each navigation, we check the user's
 *  authentication and authorization. While our
 *  checks do NOT guarentee the user has a valid
 *  session on the server each time, when they
 *  reach a page that requires server data, they
 *  will be caught there.
 */

router.beforeEach(beforeEachHandler);
